import React from 'react';
import { useObjectImportEnabled } from 'hooks/useFeatureFlag';
import intl from 'i18n/intl';
import { Button, Icon } from '@timeedit/ui-components';
import ImportObjectModal from './ImportObjectModal';

const language: any = intl.messages;

type Props = {
  objectTypeId: string | number;
};

const ImportObjectsButton: React.FC<Props> = ({ objectTypeId }) => {
  const objectImportEnabled = useObjectImportEnabled();
  const [open, setOpen] = React.useState(false);

  const handleOpenChange = (isOpen: boolean) => {
    setOpen(isOpen);
  };

  if (!objectImportEnabled) {
    return null;
  }

  return (
    <>
      <Button
        icon={<Icon id="ImportOutlined" alt="Import" />}
        onClick={() => handleOpenChange(true)}
      >
        {language.import_objects}
      </Button>
      <ImportObjectModal
        open={open}
        onClose={() => handleOpenChange(false)}
        objectTypeId={objectTypeId}
      />
    </>
  );
};

export default ImportObjectsButton;
